// How a booked interview names itself outside this app: on a calendar chip, on a landing-page
// row, and as the .ics SUMMARY. Shared so those can't drift apart.
export const interviewTitle = (interview) =>
  `Intervju ${interview.interview_round} · ${interview.candidate_name}`

// Adapter: maps a booked interview onto the shared .ics payload (spa/src/helpers/ics.js),
// which owns the RFC 5545 encoding and the download mechanics.
//
// One definition, two callers — the landing page's Activity widget (through
// helpers/calendarEvents.js, which puts this on each provider item) and Intervjuprocess.
// Kept here rather than inline in both so the uid/filename/summary can't drift apart.
//
// The slot columns are wall-clock text off v_candidate_interview ('2026-08-05T10:00:00', no
// Z) and are passed through UNTOUCHED. Do not reach for a provider item's own `start`/`end`
// instead: those are .toISOString()'d instants with a Z, and a floating DTSTART built from
// one would be off by the viewer's offset — the exact bug the wall-clock convention exists
// to prevent.
//
// `interview_end_timestamp` is nullable in the view (to_char(NULL) → NULL); the shared
// builder falls back to the start, the same as an event with no end.
export const icsFromInterview = (interview) => ({
  uid:          `${interview.candidate_interview_uuid}@kayenta-apps`,
  title:        interviewTitle(interview),
  start:        interview.interview_start_timestamp,
  end:          interview.interview_end_timestamp,
  location:     interview.interview_location,
  description:  interview.interview_note,
  filenamePart: `intervju_${interview.interview_round}_${interview.candidate_name || ''}`,
})
